import React, { createContext, useContext, useState } from 'react';

const Ctx = createContext(null);

export function NfpRegProvider({ children }) {
  const [registration, setRegistration] = useState(null); // server doc
  const [draft, setDraft] = useState({}); // local UI state (Step 1..4)

  return (
    <Ctx.Provider value={{ registration, setRegistration, draft, setDraft }}>
      {children}
    </Ctx.Provider>
  );
}

export function useNfpReg() {
  const v = useContext(Ctx);
  if (!v) throw new Error('useNfpReg must be used within NfpRegProvider');
  return v;
}
